 import React, { useEffect, useState } from 'react';
import { ThemeProvider } from '@emotion/react';
import { Global } from '@emotion/react';
import PropTypes from 'prop-types';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer} from 'react-notifications';
import 'typeface-open-sans';
import 'typeface-candal';
// import core components
import { Footer } from 'components/Footer';
import { Header } from 'components/Header';
import global from '../styles/global';
import theme from '/config/theme';

const Layout = ({ children, title, noFooter = false }) => {

  return (
    <ThemeProvider theme={theme}>
        <Global styles={global} />        
        <NotificationContainer/>
        <Header />{children}{!noFooter&&<Footer />}
    </ThemeProvider>
  );
};
export default Layout;

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]).isRequired,
};
